import React, { useContext } from 'react';
import { SignUpFormContext } from './SignUpFormProvider';
import SignUpFormView from './SignUpFormView';

const SignUpFormContainer = (props) => {
    const formContext = useContext(SignUpFormContext);
    return <SignUpFormView {...props} {...formContext} />;
};

export default SignUpFormContainer;
